import React, { Component } from 'react';

import data from '../../../core/data';
import bbHero from '../../../images/bb-cream/bb-hero.jpg';

const Blogzilla = (props) => {
  return (
    <div className="col-md-5 blog-wrapper">
      <a href={ props.route }>
        <h2 className="uppercase heading">{ props.data.heading }</h2>
      </a>
      <a className="thumbnail" href={ props.route }>
        <img src={ props.data.image } />
      </a>
      <p>{ props.data.subheading }</p>
      <a href={ props.route }>
        <div className="read-more"><p>Read More</p></div>
      </a>
    </div>
  )
};

export default class BlogCollection extends Component {

  render() {
    return (
      <section id="blogs">
        <div className="container-fluid">
          <div className="row">
            <Blogzilla route="/harpers-bazaar-2015" data={ data.news[3] } />
            <Blogzilla route="/wellbeing-2013" data={ data.news[4] } />
            <Blogzilla route="/signature-2012" data={ data.news[5] } />
            <Blogzilla route="/jetstar-2015" data={ data.news[6] } />
            <Blogzilla route="/difference-hap" data={ data.news[0] } />
            <Blogzilla route="/different-perpective" data={ data.news[1] } />
            <Blogzilla route="/the-difference" data={ data.news[2] } />
          </div>
        </div>
      </section>
    )
  }

};



/** WEBPACK FOOTER **
 ** ./src/components/containers/news/BlogCollection.jsx
 **/